const login = "login/login";
const customer_list = "wolfengine/api-user/organization";
const org_user_list = "org-user/user-list"; //用户管理-用户列表
const get_user_cars = "org-user/get-user-cars";
const get_menus_list = "menus/index";
const add_org_user = "org-user/add-user"; //添加用户
const country_code = "org-user/get-country-code"; //获取地区区号
const allrole_list = "user-role/all-roles"; //获取全部角色-不分页
const get_org_user_details = "org-user/user-detail"; //用户管理-用户详情
const org_user_change_status = "org-user/change-status"; //更改用户状态
const vehicle_management_list = "/wolfengine/api-user/organization/vehicles";
const add_car_client = "/api-user/org-vehicles/addRelation";
const vehicle_managementVIN_list = "org-user/org-vins";
const remove_car_client = "/api-user/org-vehicles/cancleRelation";
const work_station_list = "wob/xdc/ws/list";
const edit_workstation = "/wob/xdc/ws/update";
const add_workstation = "/wob/xdc/ws/create";
const get_org_user_lists = "org-user/org-user-list"; //客户管理-用户列表
const get_bind_user_list = "org-user/get-bind-user-list"; //获取待绑定用户列表
const org_bind_user = "org-user/org-bind-user"; //客户管理-添加客户（绑定）
const del_user_status = "org-user/change-org-user-status"; //客户管理-批量删除用户关系
const reset_passwd = "org-user/reset-passwd"; //密码重置接口
const car_list = "cars/car-lists";
const cron_task_list = "booking-task/booking-task-list";
const basic_info = "cars/basic-info";
const password_reset = "cars/change-pad-password";
const change_vn = "cars/edit-car-info";
const version_info = "cars/version-info";
const hw_version_info = "cars/hw-version-info";
const cars_source_statistics = "cars/source-statistics";
const get_cars_task_statistics = "wv/statistics/cars-list";
const download_raw_cars_statistics = "wv/statistics/multi-original-download";
const download_cars_statistics = "wv/statistics/multi-download";
const download_statistics = "wv/statistics/single-download";
const get_car_statistics = "wv/statistics/index";
const car_cardatastatistics_details = "wv/statistics/detail"; //单车详情
const get_user_info = "userManagement/information/index";
const edit_user_info = "userManagement/information/modify-info";
const change_pw = "userManagement/information/modify-password";
const usermanagelist = "userManagement/users/list";
const role_list = "userManagement/users/role-list";
const user_cars = "cars/user-cars";
const add_user = "userManagement/users/add-user";
const edit_user = "userManagement/users/edit-user";
const user_detail = "userManagement/users/user-detail";
const deluser = "userManagement/users/del-user";
const image_upload = "wolfengine/api-user/organization/upload";
const add_costomer = "/wolfengine/api-user/organization";
const edit_costomer = "/api-user/organization";
const costomer_details = "/api-user/organization/";
const unattended_list = "washing/unattended/index";
const get_statistics_info = "washing/unattended/statistics";
const wake_up_wake = "washing/wake-up/wake";
const wake_up_status = "washing/wake-up/status";
const task_status = "washing/restart/task-status";
const restart = "washing/restart/restart";
const current_map_id = "washing/unattended/current-map-id"; //车辆任务中信息
const tasking_info = "washing/unattended/vehicle-task"; //车辆任务中信息
const vehicle_position = "washing/unattended/vehicle-position"; //车辆位置信息
const unattended_fall_prevention = "washing/unattended/fall-prevention"; //获取防跌落位置
const map_elements = "washing/map/map-elements"; //车辆位置信息
const vehicle_map_info = "washing/unattended/vehicle-map"; //车辆地图信息
const vehicle_snap_record = "washing/unattended/snap-record";
const vehicle_snap = "washing/unattended/snap";
const log_bags = "washing/unattended/capture-bag";
const get_clean_mode_detail = "washing/unattended/get-clean-mode-detail";
const vehicle_error_msg = "washing/unattended/message";
const change_parameters = "cars/change-parameters"; //修改高级参数
const get_org_user_list = "org-user/get-org-list"; //获取客户列表（新增用户关联客户用）
const edit_org_user = "org-user/edit-user"; //编辑用户
const set_language = "menus/set-language";
const get_car_model = "cars/get-car-model";
const get_device_info = "dashboard/device-info";
const get_clean_info = "dashboard/clean-info";
const get_energy_usage = "dashboard/energy-usage";
const get_task_count = "dashboard/calc-task-count";
const get_task_end_count = "dashboard/task-end-count";
const get_statistic_clean_area = "dashboard/statistic-clean-area";
const get_statistic_clean_time = "dashboard/statistic-clean-time";
const get_statistic_clean_rate = "dashboard/statistic-clean-rate";
const get_fault_count = "dashboard/fault-count";

export default {
  login,
  customer_list,
  org_user_list,
  get_user_cars,
  get_menus_list,
  add_org_user,
  country_code,
  allrole_list,
  get_org_user_details,
  org_user_change_status,
  vehicle_management_list,
  add_car_client,
  remove_car_client,
  vehicle_managementVIN_list,
  work_station_list,
  edit_workstation,
  add_workstation,
  get_org_user_lists,
  get_bind_user_list,
  org_bind_user,
  del_user_status,
  reset_passwd,
  car_list,
  cron_task_list,
  basic_info,
  password_reset,
  change_vn,
  version_info,
  hw_version_info,
  cars_source_statistics,
  get_cars_task_statistics,
  download_raw_cars_statistics,
  download_cars_statistics,
  get_car_statistics,
  car_cardatastatistics_details,
  get_user_info,
  edit_user_info,
  change_pw,
  usermanagelist,
  role_list,
  user_cars,
  add_user,
  edit_user,
  user_detail,
  deluser,
  image_upload,
  add_costomer,
  edit_costomer,
  costomer_details,
  unattended_list,
  get_statistics_info,
  wake_up_wake,
  wake_up_status,
  task_status,
  restart,
  current_map_id,
  tasking_info,
  vehicle_position,
  unattended_fall_prevention,
  map_elements,
  vehicle_map_info,
  vehicle_snap_record,
  vehicle_snap,
  log_bags,
  get_clean_mode_detail,
  vehicle_error_msg,
  change_parameters,
  get_org_user_list,
  edit_org_user,
  download_statistics,
  set_language,
  get_car_model,
  get_device_info,
  get_clean_info,
  get_energy_usage,
  get_task_count,
  get_task_end_count,
  get_statistic_clean_area,
  get_statistic_clean_time,
  get_statistic_clean_rate,
  get_fault_count,
};
